import firebase from 'firebase/app';
import 'firebase/messaging';

let cachedTokenPromise = null;

export const initializeFirebase = () => {
  if (isIosWebView()) {
    console.log("iOS WebView wykryty – pomijam inicjalizację FCM");
    return;
  }

  const firebaseConfig = {
    apiKey: "AIzaSyDKZmg1CoaErChdjgNtKDBxdUL_3SjNGzY",
    authDomain: "trackerpinguinobe.firebaseapp.com",
    projectId: "trackerpinguinobe",
    storageBucket: "trackerpinguinobe.firebasestorage.app",
    messagingSenderId: "1062239162611",
    appId: "1:1062239162611:web:30a60db05fa6e2773f6786",
    measurementId: "G-VPJBWFG203"
  };

  firebase.initializeApp(firebaseConfig);

  // Pre-warm: if permission already granted, get token in background
  if (Notification.permission === 'granted' && 'serviceWorker' in navigator && !window.__nativePushToken) {
    cachedTokenPromise = navigator.serviceWorker.ready.then(swReg =>
      firebase.messaging().getToken({
        vapidKey: "BHseoIpZt1_p0GWZZWW9Ydqo6bx_snZPTLETk9iv3uZ7XH2RJqnq0J8hukPDnMzSm7_ZgKpNT_TOXaGd7Wp3eQQ",
        serviceWorkerRegistration: swReg
      })
    ).catch(() => null);
  }
};

function isIosWebView() {
  const ua = navigator.userAgent;
  return /iPhone|iPad|iPod/i.test(ua);
}

export const askForPermissionToReceiveNotifications = async () => {
    // If running inside the native iOS app, use the native push token
    // injected by AppDelegate instead of requesting a web push token.
    if (window.__nativePushToken) {
        console.info("[Firebase] Using native iOS push token");
        localStorage.setItem("fcm_token", window.__nativePushToken);
        return { status: "SUCCESS", token: window.__nativePushToken };
    }
    if (window.webkit?.messageHandlers?.nativePush) {
        console.info("[Firebase] Native iOS app detected, waiting for token...");
        const token = await new Promise((resolve) => {
            let attempts = 0;
            const check = setInterval(() => {
                if (window.__nativePushToken) {
                    clearInterval(check);
                    resolve(window.__nativePushToken);
                } else if (++attempts >= 50) {
                    clearInterval(check);
                    resolve(localStorage.getItem("fcm_token") || null);
                }
            }, 100);
        });
        if (token) {
            console.info("[Firebase] Got native iOS push token after waiting");
            localStorage.setItem("fcm_token", token);
            return { status: "SUCCESS", token: token };
        }
        console.warn("[Firebase] Native iOS app but no token available");
    }
  try {
    if (isIosWebView()) {
      const tokenIOS = window.localStorage.getItem('token') ?? '';
      return tokenIOS !== ''
        ? { status: "SUCCESS", token: tokenIOS }
        : { status: "FAIL", error: 'Notification permission denied' };
    } else {
      const messaging = firebase.messaging();
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        let token;
        if (cachedTokenPromise) {
          token = await cachedTokenPromise;
        }
        if (!token) {
          const swReg = await navigator.serviceWorker.ready;
          token = await messaging.getToken({
            vapidKey: "BHseoIpZt1_p0GWZZWW9Ydqo6bx_snZPTLETk9iv3uZ7XH2RJqnq0J8hukPDnMzSm7_ZgKpNT_TOXaGd7Wp3eQQ",
            serviceWorkerRegistration: swReg
          });
        }
        return token
          ? { status: "SUCCESS", token }
          : { status: "FAIL", error: 'Token is null' };
      } else {
        return { status: "FAIL", error: 'Notification permission denied' };
      }
    }
  } catch (error) {
    console.error("Błąd przy pobieraniu tokenu:", error);
    return { status: "FAIL", error };
  }
};
